import { ReactNode } from "react"

interface StatCardProps {
    label: string
    value: ReactNode
    caption?: string
    active?: boolean
    onClick?: () => void
}

// Headline number (e.g. anniversaries this month). Clickable when onClick is given: it filters the page.
const StatCard = ({ label, value, caption, active = false, onClick }: StatCardProps) => {
    const content = <>
        <span className="hr-report-stat-label">{label}</span>
        <strong className="hr-report-stat-value">{value}</strong>
        {caption && <span className="hr-report-stat-caption">{caption}</span>}
    </>

    return onClick
        ? <button type="button" className={`section-container hr-report-stat is-clickable ${active ? "is-active" : ""}`} onClick={onClick} aria-pressed={active}>{content}</button>
        : <div className="section-container hr-report-stat">{content}</div>
}

export default StatCard
